export default __webpack_public_path__ + "6849d117960cc23fe42888111185cee6.png";